import React from "react";
import { FaAngleLeft, FaAngleDoubleLeft, FaAngleRight, FaAngleDoubleRight } from 'react-icons/fa';
import { Pagination } from "react-bootstrap";
import PropTypes from "prop-types";

/**
 * Pager component to be used for easy pagination
 * @property page - Currently selected page
 * @property page_size - Number of records per page
 * @property count - Total count of all records
 * @property onChange - Callback function on page change
 */
export const Pager = props => {

    const { onChange, page, page_size, count, className } = props;

    const setPage = page => typeof onChange === 'function' && onChange(page);

    const max_pages = count > 0 ? Math.ceil(count / page_size) : 0;
    const visible_pages = 5;

    const has_first = page > 1;
    const has_last = page < max_pages;
    const has_prev = page > 1;
    const has_next = page < max_pages;
    const page_min = Math.max(1, page - ((visible_pages - 1) / 2));
    const page_max = Math.min(max_pages, page_min + visible_pages);
    const pages = [];

    for (let i = page_min; i <= page_max; i++) {
        let k = i;
        pages.push(
            <Pagination.Item key={k} active={page === k} onClick={() => setPage(k)}>{k}</Pagination.Item>
        );
    }

    return (
        <>
            { !!count && (
                <Pagination className={className} style={{ justifyContent: 'center' }}>
                    <Pagination.First disabled={!has_first} onClick={() => setPage(1)}>
                        <FaAngleDoubleLeft/>
                    </Pagination.First>
                    <Pagination.Prev disabled={!has_prev} onClick={() => setPage(page - 1)}>
                        <FaAngleLeft/>
                    </Pagination.Prev>
                    {pages}
                    <Pagination.Next disabled={!has_next} onClick={() => setPage(page + 1)}>
                        <FaAngleRight/>
                    </Pagination.Next>
                    <Pagination.Last disabled={!has_last} onClick={() => setPage(max_pages)}>
                        <FaAngleDoubleRight/>
                    </Pagination.Last>
                </Pagination>
            ) }
        </>

    );

};

Pager.defaultProps = {
    page: 1,
    page_size: 20,
    count: 0,
    className: ''
};

Pager.propTypes = {
    page: PropTypes.number,
    page_size: PropTypes.number,
    count: PropTypes.number,
    className: PropTypes.string,
    onChange: PropTypes.func
};

export default Pager;